<template>
  <div class="solution-container">
    <div class="common-container">
      <div class="common-title">
        <h2>权威的解决方案</h2>
        <p>融媒提供权威的解决方案，为开发者创建卓越价值</p>
      </div>
      <div class="solution-swiper">
        <swiper
          :modules="modules"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          navigation
          :slides-per-view="3"
          :space-between="60"
          :pagination="{ clickable: true }"
          autoplay
          loop
        >
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('live')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan01.png" alt />
                </div>

                <div class="text lanhui-text">
                  <h4>直播行业解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.15s"
            >
              <a @click="link('eBusiness')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan02.png" alt />
                </div>

                <div class="text danlv-text">
                  <h4>电商行业解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.25s"
            >
              <a @click="link('live')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan03.png" alt />
                </div>

                <div class="text lvhui-text">
                  <h4>政务民生解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.3s"
            >
              <a @click="link('product')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan04.png" alt />
                </div>

                <div class="text lvhui-text">
                  <h4>服务行业解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.35s"
            >
              <a @click="link('show')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan05.png" alt />
                </div>

                <div class="text chengse-text">
                  <h4>活动行业解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.4s"
            >
              <a @click="link('civilization')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan06.png" alt />
                </div>

                <div class="text tianlan-text">
                  <h4>文明实践解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('command')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan07.png" alt />
                </div>

                <div class="text lanhui-text">
                  <h4>指挥解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('creation')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan08.png" alt />
                </div>

                <div class="text lvhui-text">
                  <h4>创作解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('resource')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan09.png" alt />
                </div>

                <div class="text zhese-text">
                  <h4>资源解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('live')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan10.png" alt />
                </div>

                <div class="text lanse-text">
                  <h4>移动解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('paper')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan11.png" alt />
                </div>

                <div class="text qinghui-text">
                  <h4>纸媒解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('order')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan13.png" alt />
                </div>

                <div class="text zihui-text">
                  <h4>预约解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('study')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan14.png" alt />
                </div>

                <div class="text shengzhe-text">
                  <h4>学习解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('invite')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan15.png" alt />
                </div>

                <div class="text zhese-text">
                  <h4>招聘解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bounceInUpSlow wow li"
              data-wow-delay="0.1s"
            >
              <a @click="link('data')">
                <div class="img">
                  <img src="@/assets/images/icon/fangan16.png" alt />
                </div>

                <div class="text lvhui-text">
                  <h4>数据解决方案</h4>
                  <div v-waves class="span">查看详细</div>
                </div>
              </a>
            </div>
          </swiper-slide>
  
        </swiper>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { ref } from 'vue'
const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const modules = ref([Navigation, Pagination])
const link =  (name)=>{
  $$.router.push({name})
}
</script>
<style lang="less" scoped>
</style>